import React from 'react';

import styles from './Card.module.scss';

function Card(props: CardProps) {
    return (
        <div className={styles.card}>
            {props.title &&
                <header className={styles.cardheader}>
                    <h2 className={styles.cardtitle}>{props.title}&nbsp;</h2>
                </header>
            }
            <div className={styles.cardbody}>
                {props.children}
            </div>
        </div>
    );
}

class CardProps {
    children!: any;
    title?: React.ReactNode;
}

export default Card;